import { BigNumber } from 'bignumber.js';

class Decimal extends BigNumber {}

// Wrap BigNumber methods so that chained methods return Decimal rather than BigNumber
function bigNumberMethodDecorator(method) {
  return function() {
    let returnValue = method.apply(this, arguments);

    if (returnValue instanceof BigNumber) {
      returnValue = new Decimal(returnValue);
    }

    return returnValue;
  };
}

// decorate instance methods
for (let method in Decimal.prototype) {
  if (typeof Decimal.prototype[method] === 'function') {
    Decimal.prototype[method] = bigNumberMethodDecorator(Decimal.prototype[method]);
  }
}

// decorate static methods
for (let method in Decimal) {
  if (typeof Decimal[method] === 'function') {
    Decimal[method] = bigNumberMethodDecorator(Decimal[method]);
  }
}

export default Decimal;
